//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
//import Components

import {Collapse, Row, Col} from 'reactstrap'

import UpDownTransitionArrow from '../../../../components/UpDownTransitionArrow/UpDownTransitionArrow';
import AdminDepartmentForm from './AdminDepartmentForm';

import * as departmentActions from '../../HomepageManager/actions/departmentActions';

class AdminDepartmentFormManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
             collapse : props.startCollapse,

             editingId : -1,
             editing : new Array(props.datas.length).fill(false) 
        }
    }

    toggleEditing = (id) => {
        const currentEditingId = this.state.editingId;
        let newEditingId  = -1;
        let editing = [...this.state.editing];

        const currentIndex = this.props.datas.findIndex((intro) => {
            return intro.id === currentEditingId;
        })
        const newIndex = this.props.datas.findIndex((intro) => {
            return intro.id === id;
        })

        if(this.state.editingId === id) {
            editing[currentIndex] = !editing[currentIndex]
            newEditingId = -1;
        }
        else if(currentEditingId !== id) {
            if(id === null || id === undefined) {
                editing[currentIndex] = !editing[currentIndex];
                newEditingId = -1;
            } else if(currentEditingId  === -1) {
                newEditingId = id;
                editing[newIndex] = !editing[newIndex]
            }
            else {
                editing[currentIndex] = !editing[currentIndex];
                newEditingId = id;
                editing[newIndex] = !editing[newIndex];
            }
        }
        this.setState({
            editing : editing,
            editingId : newEditingId
        })

    }

    askCancleEditing = (func, id) => {
        if(this.state.editingId !== -1) {
            if(this.state.editingId === id) {
                if(func) func();
            }
            else {
                const result = global.confirm(this.props.confirmMessage);
                if (result) {
                    if (func) func();
                }
            }
        }
        else {
            if (func) func(); 
        }
    }

    toggleCollapse = ()=>{
        this.askCancleEditing(() => {
            this.toggleEditing();
            this.setState(prevState => ({
                collapse: !prevState.collapse
            }))
        })
    }

    render(){
        const renderDatas = this.props.datas && this.props.datas.map((data, index) => {
                                    return (
                                            <AdminDepartmentForm 
                                                askCancleEditing={this.askCancleEditing}
                                                toggleEditing={this.toggleEditing}
                                                editing={this.state.editing[index]}
                                                editAnything={this.state.editingId  !== -1}
                                                data={data}
                                                index={index}

                                                dbPath={this.props.dbPath}
                                                storagePath={this.props.storagePath}
                                                key={index}
                                            />
                                        )
                                    })
        const renderDataEmpty = <div className="no-data">내용이 없습니다</div>

        return (
            <div className="category">
                <div className="main-category" onClick={this.toggleCollapse}>
                    <Row>
                        <Col>
                            <h5>{this.props.title}</h5>
                        </Col>
                        <Col sm={1}>
                            <UpDownTransitionArrow up={this.state.collapse} handleOnClick={this.toggleCollapse} />
                        </Col>
                    </Row>
                </div>
                <Collapse isOpen={this.state.collapse}>
                    <div className="datas-container">
                        {
                            this.props.datas && 
                            this.props.datas.length > 0  ? renderDatas : renderDataEmpty
                        }
                        <div className="sub-category-add-btn"
                            onClick={() => this.props.onAddNewDefaultDepartment(this.props.dbPath)}
                        >
                            추가
                        </div>
                    </div>
                </Collapse>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onAddNewDefaultDepartment: (path) => {
            dispatch(departmentActions.addNewDefaultDepartment(path))
        }
    }
}

export default connect(null, mapDispatchToProps)(AdminDepartmentFormManager);

AdminDepartmentFormManager.propTypes = {
    startCollapse : PropTypes.bool,
    title : PropTypes.string.isRequired,
    confirmMessage : PropTypes.string,
    datas : PropTypes.array.isRequired,
    onAddNewDefaultData : PropTypes.func.isRequired,
    onUpdate : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired,
    storagePath : PropTypes.string.isRequired,
}

AdminDepartmentFormManager.defaultProps = {
    startCollapse : true,
    title : "관리",
    confirmMessage : "편집중인 항목이 있습니다. 취소하시겠습니까?",
    onAddNewDefaultData : null,
    onUpdate : null,
    onRemove : null,
    onOrderUp : null,
    onOrderDown : null,
    datas : []
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/AdminDepartmentFormManager.js